/**
 * Central API Manager
 * Handles all real API calls - no mock data logic here
 */

import { get, post, put, patch, del } from './client';
import { getApiUrl } from './config';

/**
 * Central API call handler
 * @param {Object} options - API call options
 * @param {string} options.endpoint - API endpoint
 * @param {string} options.method - HTTP method (GET, POST, PUT, PATCH, DELETE)
 * @param {Object} options.body - Request body (for POST, PUT, PATCH)
 * @param {Object} options.params - Query parameters
 * @param {Object} options.headers - Custom headers
 * @returns {Promise<Object>} API response
 */
export const apiCall = async ({
  endpoint,
  method = 'GET',
  body = null,
  params = null,
  headers = {},
}) => {
  try {
    let url = getApiUrl(endpoint);
    console.log('API URL:', url); // ← add this temporarily
    console.log('Params:', params); // ← and this

    console.log('Final URL:', url);
    
    // Add query parameters if provided
    if (params) {
      const queryString = Object.entries(params)
        .filter(([_, v]) => v != null)
        .map(([k, v]) => `${k}=${encodeURIComponent(v).replace(/%2F/g, '/')}`)
        .join('&');
      url += `?${queryString}`;
    }

    // Call appropriate HTTP method
    let response;
    switch (method.toUpperCase()) {
      case 'GET':
        response = await get(url, { headers,credentials: 'include' });
        break;
      case 'POST':
        response = await post(url, body, { headers });
        break;
      case 'PUT':
        response = await put(url, body, { headers });
        break;
      case 'PATCH':
        response = await patch(url, body, { headers });
        break;
      case 'DELETE':
        response = await del(url, { headers });
        break;
      default:
        throw new Error(`Unsupported HTTP method: ${method}`);
    }

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    console.error('API Call Error:', error);
    return {
      success: false,
      error: error.message || 'An error occurred',
    };
  }
};

/**
 * Helper function for GET requests
 */
export const apiGet = (endpoint, options = {}) => {
  return apiCall({
    ...options,
    endpoint,
    method: 'GET',
  });
};

/**
 * Helper function for POST requests
 */
export const apiPost = (endpoint, body, options = {}) => {
  return apiCall({
    ...options,
    endpoint,
    method: 'POST',
    body,
  });
};

/**
 * Helper function for PUT requests
 */
export const apiPut = (endpoint, body, options = {}) => {
  return apiCall({
    ...options,
    endpoint,
    method: 'PUT',
    body,
  });
};

/**
 * Helper function for PATCH requests
 */
export const apiPatch = (endpoint, body, options = {}) => {
  return apiCall({
    ...options,
    endpoint,
    method: 'PATCH',
    body,
  });
};

/**
 * Helper function for DELETE requests
 */
export const apiDelete = (endpoint, options = {}) => {
  return apiCall({
    ...options,
    endpoint,
    method: 'DELETE',
  });
};
